import React, { useEffect, useState } from "react";
import { CmpTemplates } from "../../components/template/CmpTemplates";
import UserAccountFindPageContent from "../../components/organisms/UserAccountPageContent";
import { useForm } from "react-hook-form";
import { useRecoilState } from "recoil";
import { accountFind } from "../../states/user";
import { useNavigate } from "react-router";

const UserAccountFindPage = () => {
  const navigate = useNavigate();
  const [accountData, setAccountData] = useRecoilState(accountFind);
  const [isNext, setIsNext] = useState<boolean>(false);

  const { register, setValue, reset, watch } = useForm<any>();

  useEffect(() => {
    const isTrue = Object.values(watch()).some(
      (value) => typeof value === "string" && value.trim() !== ""
    );

    setIsNext(isTrue);
  }, [watch()]);

  useEffect(() => {
    reset(accountData);
  }, [accountData]);

  const onUserPasswordChangeHanlder = () => {
    navigate("/user-password-change");
    setAccountData((prev: any) => ({
      ...prev,
      username: watch("username"),
      phoneNumber: watch("phoneNumber"),
    }));
  };

  const onUserBackPageMoveHanlder = () => {
    navigate("/");
  };

  return (
    <CmpTemplates pageTitle="계정정보 찾기">
      <UserAccountFindPageContent
        onUserPasswordChangeHanlder={onUserPasswordChangeHanlder}
        onUserBackPageMoveHanlder={onUserBackPageMoveHanlder}
        register={register}
        setValue={setValue}
        isNext={isNext}
      />
    </CmpTemplates>
  );
};

export default UserAccountFindPage;
